import {Subscription} from 'rxjs';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxPopupComponent} from '../../../../shared/ngx-popups/ngx-popups/components/popup.component';
import {AutoUnsubscribe} from '../../../../../decorators/auto-unsubscribe';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-attestation-popup',
    templateUrl: './attestation-popup.component.html',
    styleUrls: ['./attestation-popup.component.scss'],
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class AttestationPopupComponent implements OnInit {
  @Input() popup: NgxPopupComponent;
  @Input() title = 'ATTESTATION';
  @Input() attestationText: string;
  @Input() danger: boolean;
  @Input() confirmButtonText = 'Complete Spread';
  @Input() cancelButtonText = 'Cancel';
  @Input() headerIcon?: string = 'fa-stamp'

  @Output() callback = new EventEmitter<boolean>();

  attestationForm: FormGroup;
  subsArr$: Subscription[] = [];

  constructor(
    private formBuilder: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.attestationForm = this.formBuilder.group({
      attestationCheckbox: [false, Validators.requiredTrue]
    })
  }

  submitForm() {
    if (this.attestationForm.valid) {
      this.callback.emit(true);
      this.popup.close();
    } else {
      this.attestationForm.markAllAsTouched();
    }
  }

  closeModal() {
    this.callback.emit(false);
    this.popup.close();
  }
}
